import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import TextInput from '../../inputs/text'
import css from './content-url.css'

/**
 * Edit Panel - Content URL: Controls
 * the content URL input in the GIF
 * Edit Panel. This input can be shown
 * or hidden as an advanced option.
 *
 * @class EditPanelContentURL
 */
export default class extends Component {
    static propTypes = {
        className: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
    }
    state = {
        isOpen: false,
    }
    onToggleOpen() {
        this.setState(prevState => {
            return { isOpen: !prevState.isOpen }
        })
    }
    render() {
        const { className, value, onChange } = this.props
        const { isOpen } = this.state
        return (
            <div className={className}>
                <span className={css.toggle} onClick={() => this.onToggleOpen()}>
                    Content URL <i className={isOpen ? css.toggleClose : css.toggleOpen} />
                </span>
                {isOpen && (
                    <div className={css.inputWrapper}>
                        <TextInput
                            type="url"
                            value={value}
                            placeholder="Add a content URL"
                            buttonLabel="Save"
                            onSubmit={onChange}
                        />
                    </div>
                )}
            </div>
        )
    }
}
